<span class="app-link" [class]="styleClass" [ngSwitch]="item.urlType" (mousedown)="handleMouseDown($event, item)">
  <a
    *ngSwitchCase="linkTypeEnum.URL"
    [id]="item.id"
    [href]="item.url"
    [class]="item.styleClass"
    [ngClass]="{ active: isActive, icon: item.iconUrl}"
    [ngStyle]="linkStyle"
    [title]="item.hint || ''"
    >{{ item.label }}</a
  >
  <a
    *ngSwitchCase="linkTypeEnum.ROUTER_LINK"
    [id]="item.id"
    [routerLink]="item.url"
    [class]="item.styleClass"
    [ngClass]="{ active: isActive, icon: item.iconUrl }"
    [ngStyle]="linkStyle"
    [title]="item.hint || ''"
  >
    {{ item.label }}
  </a>
  <a
    *ngSwitchCase="linkTypeEnum.URL_NEW_TAB"
    [href]="item.url"
    target="_blank"
    [class]="item.styleClass"
    [ngClass]="{ active: isActive, icon: item.iconUrl }"
    [ngStyle]="linkStyle"
    [title]="item.hint || ''"
  >
    {{ item.label }}
  </a>
  <span
    *ngSwitchDefault
    [id]="item.id"
    [class]="item.styleClass"
    [ngClass]="{ active: isActive, icon: item.iconUrl }"
    [title]="item.hint || ''"
    >{{ item.label }}</span
  >
</span>
